export default __webpack_public_path__ + "static/media/javamap.a4cf228b.png";